export type Brand = 'fuzerx';

/**
 * Get the brand of the current app. Post-rebrand there is one brand: FuzeRx.
 * Old native installs keep whatever brand their binary shipped with — this only affects builds
 * cut from here on.
 */
export const getBrand = (): Brand => 'fuzerx';
